import { Component, inject, OnInit } from '@angular/core';
import { CommonFunctionsService } from '../../services';
import { NavigationEnd, Router } from '@angular/router';
import { DatastoreService } from '../../services';
import { filter, map, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
	Category,
	Enhancement,
	EnhancementsService,
} from '../../services/enhancements.service';
import { isOurCeremonyFeatureEnabled } from '../../services/guards/feature-toggle.guard';
import { isExternalVenueBooking } from '../../services/guards/external-venue-add-ons.guard';

@Component({
	selector: 'app-menu',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
	companyId: number;
	companyName: string;
	currentPage: string;
	isMenuOpen = false;
	activeRoute: string;
	service: Record<string, any>;
	categories$: Observable<Category[]>;
	booking: Record<string, any>;
	canViewAddOns = false;
  config: any;
  excludedChoicesServiceIds: any[] = [];
  hideGiveNoticeServiceIds: any[] = [];

	enahncementsService = inject(EnhancementsService);

	constructor(
		private commonFunctionsService: CommonFunctionsService,
		private router: Router,
		private dataStore: DatastoreService
	) {}

	ngOnInit(): void {
    const configStr = this.dataStore.config;
    const config = JSON.parse(configStr);
    this.config = config;
		this.companyId = this.commonFunctionsService.getCompanyId();
		this.companyName = this.commonFunctionsService.getCompanyName();

    if (this.config.hasOwnProperty('myCeremony')) {
		if (this.config.myCeremony.hasOwnProperty('optional-addons')) {
			this.canViewAddOns = this.config.myCeremony['optional-addons'].enabled;
		}
      if (this.config.myCeremony.hasOwnProperty('give-notice')) {
        if (this.config.myCeremony['give-notice'].hasOwnProperty('rules')) {
          if (this.config.myCeremony['give-notice'].rules.hasOwnProperty('hideMenuFromServiceIds')) {
            this.hideGiveNoticeServiceIds = this.config.myCeremony['give-notice'].rules.hideMenuFromServiceIds;
          }
        }
      }
      if (this.config.myCeremony.hasOwnProperty('general')) {
        console.log(this.config.myCeremony.general.excludedChoicesServiceIds);
        if (this.config.myCeremony.general.hasOwnProperty('excludedChoicesServiceIds')) {
          if (this.config.myCeremony.general.excludedChoicesServiceIds.length > 0) {
            for (const item of this.config.myCeremony.general.excludedChoicesServiceIds) {
              this.excludedChoicesServiceIds.push(item);
            }
            this.dataStore.excludedChoicesServiceIds = this.excludedChoicesServiceIds;
          }
        }
      }
    }

		this.dataStore.pageChanged.subscribe((page) => {
			this.currentPage = page;
		});

		this.service = this.dataStore.selectedService;
		if (!this.service) {
			const serviceStr = localStorage.getItem('service') as string;
			this.service = JSON.parse(serviceStr);
		}
    // console.log('current service', this.service.id, this.service.global_id, this.excludedChoicesServiceIds.includes(this.service.global_id));
    if (this.excludedChoicesServiceIds.includes(this.service.global_id)) {
      console.log(`Hiding service ${this.service.global_id} (${this.service.id}) due to matching excludedChoicesServiceIds.`);
    }

		this.booking = this.dataStore.booking;
		if (!this.booking) {
			const bookingStr = localStorage.getItem('ceremony') as string;
			this.booking = JSON.parse(bookingStr);
		}

		this.categories$ = this.enahncementsService
			.getEnhancements(this.booking.company_id, this.service.global_id)
			.pipe(
				map((enhancements: Enhancement[]) =>
					this.enahncementsService.getCategories(enhancements)
				)
			);

		//set the router url they originally come from and subscribe to router
		this.activeRoute = this.router.url;
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				this.activeRoute = this.router.url; // Store the active route
			});
	}

	async navigateTo(
		route: string,
		queryParams: Record<string, any> = undefined
	) {
		console.log('Navigating to:', route, 'with query params:', queryParams);
		this.commonFunctionsService.navigateToFrom(
			route,
			this.currentPage,
			queryParams
		);
	}

	toggleMenu() {
		this.isMenuOpen = !this.isMenuOpen; // Toggle mobile menu visibility
	}

	get canPurchaseAddons(): boolean {
		// Hidden until a booking is resolvable, so the links don't flash
		// visible for an external-venue booking while it loads.
		const booking = this.dataStore.booking || this.booking;
		if (!booking) {
			return false;
		}
		return (
			isOurCeremonyFeatureEnabled(this.dataStore, 'can_purchase_addons') &&
			!isExternalVenueBooking(this.dataStore)
		);
	}

	get showGiveNotice(): boolean {
		if (this.hideGiveNoticeServiceIds.length === 0) {
			return true;
		}
		const booking = this.dataStore.booking || this.booking;
		if (!booking) {
			return true;
		}
		return !this.hideGiveNoticeServiceIds.some(
			(id: any) => Number(id) === Number(booking.service_id)
		);
	}

	isActive(url: string, category?: string) {
		if (category) {
			url = url + `?category=${category}`;
		}
		return this.activeRoute?.startsWith(
			`/${this.companyName}/${this.companyId}/${url}`
		);
	}

	signOut() {
		this.commonFunctionsService.logout();
	}
}
